import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mx-auto mb-12 flex max-w-[1280px] justify-end max-lg:mx-3 lg:mb-20',
    content:
      'absolute top-[14px] right-0 left-4 lg:top-0 lg:right-auto lg:left-0',
    text: 'text-sm leading-[1.5] md:max-w-[38%] lg:max-w-none lg:text-base',
    buttonDesktop:
      'bg-brand-bioderma mt-12 hidden max-w-[306px] font-medium normal-case lg:flex',
    buttonMobile:
      'bg-brand-bioderma mt-7 mr-4 flex font-medium normal-case lg:hidden',
    logo: 'mb-5 max-lg:max-w-[216px] lg:mb-6',
    info: 'lg:max-w-[434px] lg:pt-15 lg:pl-[70px]',
    advantages:
      'scrollbar-hidden flex gap-2 overflow-x-scroll pt-8 lg:pt-[74px] lg:pl-[70px]',
    advantage:
      "lg:gaccent-pink-400 relative flex min-w-fit items-center gap-2 overflow-hidden rounded-[51px] border-x-1 border-y-3 border-white/80 bg-white/60 p-[2px] pr-8 shadow-[inset_0_6px_28px_rgba(255,255,255,0.06),inset_0_-6px_28px_rgba(0,0,0,0.04),inset_0_0_1px_rgba(0,0,0,0.05)] backdrop-blur-xl backdrop-saturate-150 before:absolute before:inset-x-0 before:top-0 before:h-[60%] before:bg-gradient-to-b before:from-white/18 before:to-transparent before:opacity-80 before:blur-[1px] before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-[60%] after:bg-gradient-to-t after:from-white/24 after:to-transparent after:opacity-70 after:blur-[1px] after:content-[''] max-lg:last:mr-4",
    advantageImage: 'max-lg:max-h-16 max-lg:max-w-16',
    visual: 'w-full object-cover',
    advantageText:
      'text-sm leading-[1.4] font-medium max-md:max-w-[162px] lg:text-base',
    image:
      'overflow-hidden md:min-h-110 md:rounded-[40px] md:object-cover lg:min-h-155',
    strong: 'font-bold',
    br: 'hidden lg:block'
  }
});
